import { useQuery } from "@tanstack/react-query";
import { getModelBlocks } from "./getModelBlocks";
import { useSelectedSimulation } from "@/hooks";

export function useGetModelBlocksBySimulationId() {
    const { selectedSimulation } = useSelectedSimulation();

    return useQuery({
        queryKey: ["model-blocks", selectedSimulation?.id],
        queryFn: () => getModelBlocks(selectedSimulation?.id),
        enabled: !!selectedSimulation?.id,
        initialData: [],
    });
}
